module.exports = __webpack_public_path__ + "static/media/mito36.b6c7db0a.jpg";